import { Steps } from "antd";
import React from "react";
import "./index.css";

const { Step } = Steps;

const customDot = (_dot, { status }) => {
  return (
    <>
      {status === "wait" ? (
        <div className="not-completed-step-dot"/>
      ) : (
        <div className="completed-step-dot"/>
      )}
    </>
  );
};

function StepProgressComponent({ steps, currentStep }) {
  return (
    <div className="progress-component">
      <Steps
        current={currentStep}
        progressDot={customDot}
      >
        {steps.map((step, index) => {
          return (
            <Step
              key={index}
              title={step}
            />
          );
        })}
      </Steps>
    </div>
  );
}

export default StepProgressComponent;
